import { ContentTypes } from './content-types';

export const ContentTypeRouterPaths = {
  [ContentTypes.ARTICLE]: 'articles',
  [ContentTypes.GALLERY]: 'galleries',
  [ContentTypes.NEWS_BRIEF]: 'new-briefs',
  [ContentTypes.PAGE]: 'pages',
  [ContentTypes.DIGITAL_PUBLICATION]: 'digital-publications',
  [ContentTypes.SINGLE_SPONSOR]: 'single-sponsor',
  [ContentTypes.CONTENT_SET]: 'content-set',
};
